var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Element/Misc/Circle Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-9---Search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.6--User-result---edit",
    transform: "translate(-181.000000, -718.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-info",
    transform: "translate(149.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeline",
    transform: "translate(32.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element/Misc/Circle-Icon",
    transform: "translate(0.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Base",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.2,
    mask: "url(#mask-2)",
    fill: "#1DDCC0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Element/Icon/Message",
    mask: "url(#mask-2)",
    fill: "#1DDCC0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 11.000000)",
    id: "\\uD83C\\uDFA8-Icon-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6682301,2.03055194 L4.79977373,9.25121725 C4.35741391,9.71626092 3.64126617,9.71626092 3.20003771,9.25121725 L0.330921347,6.23616428 C-0.110307116,5.77112061 -0.110307116,5.0182494 0.330921347,4.55320572 C0.773281165,4.08935142 1.4894289,4.08935142 1.93065736,4.55320572 L3.99990572,6.72856346 L10.0684941,0.348782754 C10.5097226,-0.116260918 11.2258703,-0.116260918 11.6682301,0.348782754 C12.11059,0.812637056 12.11059,1.56550827 11.6682301,2.03055194"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6af22933c5e11fe6060742e420a09967.svg";
export { ForwardRef as ReactComponent };